import React from "react";
import { Star, Quote } from "lucide-react";
import { useT } from "../../lib/i18n";

const REVIEWS = [
  { name: "Giulia M.", origin: "Milano", text: "Pizza davvero eccezionale: impasto leggerissimo e digeribile, si sente la lunga lievitazione. Il calzone fritto è da provare assolutamente. Staff gentilissimo.", rating: 5 },
  { name: "Marco R.", origin: "Lignano", text: "Il mio posto preferito in zona. Qualità alta e nessun coperto in conto: una rarità di questi tempi. Le capesante gratinate sono uno spettacolo.", rating: 5 },
  { name: "Anna & Paolo", origin: "Udine", text: "Dopo una giornata in spiaggia siamo capitati qui per caso. Tornati tre volte in una settimana. La tartare di manzo e il risottino ai gamberi sono da applausi.", rating: 5 },
  { name: "Hans K.", origin: "Österreich", text: "Authentische italienische Küche, Pizza wie in Neapel. Sehr freundliches Personal und faire Preise. Kommen nächstes Jahr wieder!", rating: 5 },
  { name: "Famiglia Conti", origin: "Pordenone", text: "Perfetti con i bambini, menù per tutti i gusti, tempi di attesa rapidi anche sabato sera. La margherita è stata promossa dal nostro piccolo critico di 8 anni.", rating: 5 },
  { name: "Elena S.", origin: "Trieste", text: "Ambiente curato, servizio attento. La pizza a carro di ruota è una delle migliori provate in Friuli. Menù ampio, pesce freschissimo.", rating: 5 },
];

const Stars = ({ value }) => (
  <div className="flex gap-0.5" aria-label={`${value}/5`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className={`w-4 h-4 ${i < value ? "fill-[#B59410] text-[#B59410]" : "text-stone-300"}`} />
    ))}
  </div>
);

const ReviewCard = ({ review, delay = 0 }) => (
  <article
    data-testid={`review-card-${review.name.toLowerCase().replace(/[^a-z]/g, '-')}`}
    className="relative bg-white rounded-3xl border border-[#1E3A5D]/10 shadow-sm p-7 sm:p-8 flex flex-col hover:-translate-y-1 hover:shadow-lg transition-all duration-300 animate-fade-up"
    style={{ animationDelay: `${delay}ms` }}
  >
    <Quote className="w-10 h-10 text-[#B59410]/20 -mt-1" strokeWidth={1} />
    <p className="mt-3 text-[#1E3A5D] text-base sm:text-lg leading-relaxed font-serif-body italic flex-1">
      "{review.text}"
    </p>
    <div className="mt-6 pt-5 border-t border-[#1E3A5D]/10">
      <Stars value={review.rating} />
      <p className="mt-3 font-display text-sm text-[#1E3A5D] tracking-[0.12em] font-semibold">
        {review.name}
      </p>
      <p className="mt-1 text-[#1E3A5D]/55 text-xs font-serif-body">
        {review.origin}
      </p>
    </div>
  </article>
);

export const Testimonials = () => {
  const { t } = useT();
  return (
    <section
      id="recensioni"
      data-testid="testimonials-section"
      className="py-20 sm:py-28 bg-[#F5EFE4]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="font-display text-xs text-[#B59410] tracking-[0.3em] font-semibold">
            {t("reviews.eyebrow")}
          </span>
          <h2 className="mt-3 font-script text-6xl sm:text-7xl lg:text-8xl text-[#1E3A5D] leading-none">
            {t("reviews.title")}
          </h2>
          <div className="mx-auto mt-4 flex items-center gap-3 justify-center">
            <span className="h-px w-10 bg-[#B59410]" />
            <span className="text-[#B59410] text-xs font-display tracking-[0.3em]">
              {t("reviews.subtitle")}
            </span>
            <span className="h-px w-10 bg-[#B59410]" />
          </div>

          <div className="mt-8 inline-flex items-center gap-4 bg-white border border-[#1E3A5D]/10 rounded-full px-6 py-3 shadow-sm">
            <Stars value={5} />
            <div className="text-left">
              <p className="font-display text-sm text-[#1E3A5D] font-semibold tracking-wider">4.8 / 5</p>
              <p className="text-[#1E3A5D]/60 text-xs font-serif-body">{t("reviews.basedOn")}</p>
            </div>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-7">
          {REVIEWS.map((r, i) => (
            <ReviewCard key={r.name} review={r} delay={i * 80} />
          ))}
        </div>

        <p className="text-center mt-12 text-[#1E3A5D]/60 text-sm font-serif-body italic">
          {t("reviews.outro")}{" "}
          <a
            href="https://www.google.com/maps/search/?api=1&query=Mama+Cucina+e+Pizza+Lignano+Sabbiadoro"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="write-review-link"
            className="text-[#B59410] hover:text-[#8E7308] font-semibold not-italic"
          >
            {t("reviews.leaveLink")}
          </a>
        </p>
      </div>
    </section>
  );
};
